import developerRoutes from "developer/routes";

type DrawerData = {
  name: string;
  text: string;
  to: string;
  children?: DrawerData[];
};

export const MODULES_DRAWER_DATA: DrawerData[] = [
  {
    name: "FormDefinitions",
    text: "Form Definitions",
    to: developerRoutes.FORM_DEFINITIONS,
  },
  {
    name: "Resources",
    text: "Resources",
    to: developerRoutes.RESOURCES,
  },
  // Example of an item with nested items
  // {
  //   name: "Interfaces",
  //   text: "Interfaces",
  //   to: "",
  //   children: [
  //     {
  //       name: "Proveedores",
  //       text: "Proveedores",
  //       to: interfacesRoutes.INTERFACES_PROVEEDORES_EXPLORADOR,
  //     },
  //     {
  //       name: "Contratos",
  //       text: "Contratos",
  //       to: interfacesContratosRoutes.CONTRATOS_CABECERA,
  //     },
  //   ],
  // },
];
